import { styled } from '@mui/material';

export const Root = styled('div')({
  zIndex: 1100,
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  height: 0,
});

export const ButtonStyled = styled('div')(({ theme }) => ({
  position: 'absolute',
  display: 'flex',
  alignSelf: 'center',
  justifyContent: 'center',
  alignItems: 'center',
  height: 28,
  minWidth: 28,
  borderRadius: 100,
  backgroundColor: theme.palette.grey[100],
  cursor: 'pointer',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
}));

export const ButtonContent = styled('div')({
  display: 'flex',
  alignItems: 'center',

  [`&:hover`]: {
    paddingLeft: 8,
    paddingRight: 8,
  },
});
